import {
    BUILDING_CONSTRUCTION_REQUEST,
    BUILDING_CONSTRUCTION_ERROR,
    BUILDING_CONSTRUCTION_SUCCESS,
    BUILDING_CONSTRUCT_CONFIRMATION_OPEN,
    BUILDING_CONSTRUCT_CONFIRMATION_CLOSE,
} from 'state/actions/building_construction'

const initialState = {
    submitting: false,
    submitted: false,
    errorMessage: '',
    confirmationOpened: false,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case BUILDING_CONSTRUCTION_REQUEST: {
        return {
            ...state,
            submitted: false,
            submitting: true,
            errorMessage: '',
            confirmationOpened: false,
        }
    }
    case BUILDING_CONSTRUCTION_SUCCESS: {
        return {
            ...state,
            submitted: true,
            submitting: false,
        }
    }
    case BUILDING_CONSTRUCTION_ERROR: {
        return {
            ...state,
            submitted: false,
            submitting: false,
            errorMessage: action.payload.errorMessage,
        }
    }
    case BUILDING_CONSTRUCT_CONFIRMATION_OPEN: {
        return {
            ...state,
            confirmationOpened: true,
        }
    }
    case BUILDING_CONSTRUCT_CONFIRMATION_CLOSE: {
        return {
            ...state,
            confirmationOpened: false,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/building_construction.js